export default __webpack_public_path__ + "static/media/exclametryred.ebd5246d.svg";